/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Foerderbedarflauteltern2Inputs */

const de__field_foerderbedarflauteltern2 = /** @type {(inputs: _Field_Foerderbedarflauteltern2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förderbedarf des Kindes`)
};

/**

* @param {_Field_Foerderbedarflauteltern2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_foerderbedarflauteltern2 = /** @type {((inputs?: _Field_Foerderbedarflauteltern2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Foerderbedarflauteltern2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_foerderbedarflauteltern2(inputs)
});
export { _field_foerderbedarflauteltern2 as "_field_foerderbedarfLautEltern" }